module.exports = __webpack_public_path__ + "static/img/manufacture-300x300.55eaecca.jpg";